module.exports = __webpack_public_path__ + "img/Unity.0a5aba11.png";